import { useAccount } from '@lib/context/account-context'
import Overview from '@modules/account/components/overview'
import { useCustomerOrders, useMeCustomer } from 'medusa-react'

const OverviewTemplate = () => {
  // Include metadata field
  const { orders } = useCustomerOrders({
    fields: 'display_id,metadata',
    limit: 100,
    offset: 0,
  })
  const { customer, isApproved, isRejected, isSetUp, retrievingCustomer } =
    useAccount()
  return (
    <Overview
      orders={orders}
      customer={customer}
      isAccountApproved={isApproved}
      isAccountSetUp={isSetUp}
      isAccountRejected={isRejected}
      loadingCustomer={retrievingCustomer}
    />
  )
}

export default OverviewTemplate
